import React from 'react';

import { FileDrop } from 'react-file-drop';

import './styles.scss';

interface IDocumentUploadPageProps {
    className?: string;
    clickToUpload?: boolean;
    onDrop: (files: FileList | null, event: React.DragEvent<HTMLDivElement>) => void;
    onFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FileUploadDragAndDrop = (
    {
        children,
        className,
        clickToUpload,
        onDrop,
        onFileInputChange
    }: React.PropsWithChildren<IDocumentUploadPageProps>
) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const onTargetClick = (): void => {
        fileInputRef.current?.click();
    };

    return (
        <FileDrop className={`file-drop ${className}`} onDrop={onDrop} onTargetClick={onTargetClick}>
            {children}
            {clickToUpload && (
                <input
                    onChange={onFileInputChange}
                    ref={fileInputRef}
                    type="file"
                    hidden
                />
            )}
        </FileDrop>
    );
};

FileUploadDragAndDrop.defaultProps = {
    clickToUpload: true
};
